import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import { toast } from 'react-toastify';
import Api from '../../../Api';
import { Modal, Input, Select, MultiSelect, Button, RangeSlider } from '../../../components';
import './style.css';

const TARGET_TYPES = [
  { value: '', label: 'SELECIONE...' },
  //{ value: 'employee', label: 'Funcionário' },
  { value: 'customer', label: 'Cliente' },
  //{ value: 'supplier', label: 'Fornecedor' },
  //{ value: 'accountant', label: 'Contador' },
  //{ value: 'user', label: 'Usuário' },
  { value: 'service_station', label: 'Posto de Serviço' },
];

const TARGET_TYPES_EXECUTORS = [
  { value: '', label: 'SELECIONE...' },
  { value: 'employee', label: 'Funcionário' },
  //{ value: 'customer', label: 'Cliente' },
  //{ value: 'supplier', label: 'Fornecedor' },
  //{ value: 'accountant', label: 'Contador' },
  //{ value: 'user', label: 'Usuário' },
  //{ value: 'service_station', label: 'Posto de Serviço' },
];

const SERVICE_TYPES = [
  { value: '', label: 'SELECIONE...' },
  { value: 'cortesia', label: 'Cortesia' },
  { value: 'terceirizado', label: 'Terceirizado' },
  { value: 'padrao', label: 'Padrão' },
];

const REQUEST_TYPES = [
  { value: '', label: 'SELECIONE...' },
  { value: 'corretiva', label: 'Corretiva' },
  { value: 'preventiva', label: 'Preventiva' },
];

const PERIOD_TYPES = [
  { value: '', label: 'Sem recorrência' },
  { value: 'custom', label: 'Datas Específicas' },
  { value: 'diario', label: 'Diário' },
  { value: 'semanal', label: 'Semanal' },
  { value: 'quinzenal', label: 'Quinzenal' },
  { value: 'mensal', label: 'Mensal' },
  { value: 'bimestral', label: 'Bimestral' },
  { value: 'trimestral', label: 'Trimestral' },
  { value: 'semestral', label: 'Semestral' },
  { value: 'anual', label: 'Anual' },
];

const REQUIRES_PHOTOS_OPTIONS = [
  { value: 'false', label: 'Não' },
  { value: 'true', label: 'Sim' },
];

function generateTimeOptions() {
  const options = [];
  for (let h = 5; h <= 23; h++) {
    options.push({ value: `${String(h).padStart(2, '0')}:00`, label: `${String(h).padStart(2, '0')}:00` });
    options.push({ value: `${String(h).padStart(2, '0')}:30`, label: `${String(h).padStart(2, '0')}:30` });
  }
  return options;
}

const TIME_OPTIONS = [{ value: '', label: 'Nenhum' }, ...generateTimeOptions()];

export default function ServiceOrderModal({
  isOpen,
  onClose,
  initialData,
  onSuccess,
  companyId,
  companies = [],
  preloadedEmployees = [],
  preloadedCustomers = [],
  preloadedSuppliers = [],
  preloadedAccountants = [],
  preloadedUsers = [],
  preloadedServiceStations = [],
  preloadedServices = []
}) {
  const isEdit = !!(initialData && initialData.id);

  function formatCurrencyForDisplay(raw) {
    if (raw === undefined || raw === null || raw === '') {
      return '';
    }

    let value = String(raw).replace(/[^\d,.-]/g, '').replace(',', '.');
    const num = Number(value);

    if (Number.isNaN(num)) {
      return '';
    }

    const fixed = num.toFixed(2).replace('.', ',');
    const parts = fixed.split(',');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const decimalPart = parts[1];

    return `R$ ${integerPart},${decimalPart}`;
  }

  function normalizeCurrencyValue(raw) {
    if (raw == null) {
      return null;
    }

    let value = String(raw).trim();
    if (!value) {
      return null;
    }

    value = value.replace(/[R$\s]/g, '');
    const parts = value.split(',');

    if (parts.length === 1) {
      const integerPartOnly = parts[0].replace(/\./g, '');
      if (!integerPartOnly) return null;
      return `${integerPartOnly}.00`;
    }

    const integerPart = parts[0].replace(/\./g, '') || '0';
    const decimalPart = parts[1] || '00';

    return `${integerPart}.${decimalPart}`;
  }

  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);
  const [formData, setFormData] = useState({
    title: '',
    target_type: '',
    target_id: '',
    requires_photos: 'false',
    service_type: '',
    request_type: '',
    next_execution_date: '',
    period_type: '',
    period_quantity: '',
    reminder_days_before: '',
    execution_time: '',
    preferred_time: '',
    value: '',
    observation: '',
  });

  const [selectedServices, setSelectedServices] = useState([]);
  const [customDates, setCustomDates] = useState([]);
  const [tempDate, setTempDate] = useState('');
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamEntityType, setTeamEntityType] = useState('');
  const [teamEntityId, setTeamEntityId] = useState('');

  const [targetEntities, setTargetEntities] = useState([]);
  const [teamEntities, setTeamEntities] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    if (initialData && initialData.id) {
      // Carrega empresas associadas ou fallback para company_id legado
      let initialIds = [];
      if (initialData.companies && initialData.companies.length > 0) {
        initialIds = initialData.companies.map(c => String(c.id));
      } else {
        const cId = initialData._companyId || initialData.company_id || companyId;
        if (cId) initialIds = [String(cId)];
      }
      setSelectedCompanyIds(initialIds);

      setFormData({
        title: initialData.title || '',
        target_type: initialData.target_type || '',
        target_id: String(initialData.target_id || ''),
        requires_photos: String(initialData.requires_photos || false),
        service_type: initialData.service_type || '',
        request_type: initialData.request_type || '',
        next_execution_date: initialData.next_execution_date || '',
        period_type: initialData.period_type || '',
        period_quantity: initialData.period_quantity ? String(initialData.period_quantity) : '',
        reminder_days_before: initialData.reminder_days_before ? String(initialData.reminder_days_before) : '',
        execution_time: initialData.execution_time ? String(initialData.execution_time) : '',
        preferred_time: initialData.preferred_time || '',
        value: initialData.value != null ? formatCurrencyForDisplay(initialData.value) : '',
        observation: initialData.observation || '',
      });
      setSelectedServices(
        initialData.services ? initialData.services.map(s => String(s.id)) : []
      );
      setTeamMembers(
        initialData.teamMembers ? initialData.teamMembers.map(m => ({
          entity_type: m.entity_type,
          entity_id: m.entity_id,
          entity_name: m.entity_name,
        })) : []
      );
      setCustomDates(
        initialData.customDates ? initialData.customDates.map(d => d.date) : []
      );
      
      // Carrega dados baseados em TODAS as empresas da lista
      if (initialData.target_type) {
        loadEntities(initialData.target_type, 'target', initialIds);
      }
      
      const initialSelectedServiceIds = initialData.services ? initialData.services.map(s => String(s.id)) : [];
      loadServices(initialIds, initialSelectedServiceIds);
    } else {
      // Novo registro
      setSelectedCompanyIds(companyId ? [String(companyId)] : []);
      setFormData({
        title: '',
        target_type: '',
        target_id: '',
        requires_photos: 'false',
        service_type: '',
        request_type: '',
        next_execution_date: '',
        period_type: '',
        period_quantity: '',
        execution_time: '',
        preferred_time: '',
        value: '',
        observation: '',
      });
      setSelectedServices([]);
      setTeamMembers([]);
      setCustomDates([]);
      setTempDate('');
      setTargetEntities([]);
      setTeamEntities([]);
      
      if (companyId) {
          loadServices([String(companyId)], []);
      }
    }
  }, [isOpen, initialData]);

  useEffect(() => {
    if (!isOpen) return;
    
    // Se mudou a seleção de empresas e não estamos editando inicialmente (para evitar recarregar em cima do loadEntities do primeiro useEffect)
    // Mas precisamos reagir à mudança do usuário.
    // Vamos usar a lista completa de IDs
    const currentIds = selectedCompanyIds;
    
    if (currentIds.length === 0) return;

    // Lógica simplificada: Se a lista mudou em relação ao initialData
    // Como initialData tem companies array, podemos comparar
    let initialIds = [];
    if (initialData && initialData.companies) {
        initialIds = initialData.companies.map(c => String(c.id));
    } else if (initialData && (initialData.company_id || initialData._companyId)) {
        initialIds = [String(initialData.company_id || initialData._companyId)];
    }

    const isSameSet = initialIds.length === currentIds.length && initialIds.every(id => currentIds.includes(id));
    
    // Se é diferente OU se não temos dados iniciais (criação e mudou empresa)
    if (!isSameSet || !initialData || !initialData.id) {
         // Não chamamos loadServices aqui porque o onChange do Select já chama
         // loadServices(currentIds); 
         
         // Mas precisamos chamar loadEntities se já tiver um tipo selecionado
         if (formData.target_type) {
             loadEntities(formData.target_type, 'target', currentIds);
         }

         if (teamEntityType) {
             loadEntities(teamEntityType, 'team', currentIds);
         }
    }
    
  }, [selectedCompanyIds]); // Simplificado

  // Helper para obter nome da empresa
  const getCompanyName = (id) => {
    const c = companies.find(comp => String(comp.id) === String(id));
    return c ? (c.trade_name || c.corporate_name || c.name) : `Empresa ${id}`;
  };

  async function loadServices(overrideCIds = null, currentSelectedIds = null) {
    const cIds = overrideCIds || selectedCompanyIds;
    // Garante que seja um array
    const idsToLoad = Array.isArray(cIds) ? cIds : (cIds ? [cIds] : []);
    
    // Usa selectedServices do state se não for passado explicitamente
    const selectedIds = currentSelectedIds !== null ? currentSelectedIds : selectedServices;
    
    if (idsToLoad.length === 0) {
        setServiceOptions([]);
        return;
    }

    try {
      const promises = idsToLoad.map(id => Api.getServices(id).then(data => ({ id, data })).catch(err => ({ id, data: [], error: err })));
      const results = await Promise.all(promises);
      
      const grouped = {};
      
      results.forEach(({ id, data }) => {
          if (Array.isArray(data)) {
              data.forEach(s => {
                  const key = s.name.trim();
                  if (!grouped[key]) {
                      grouped[key] = [];
                  }
                  grouped[key].push(s.id);
              });
          }
      });
      
      const newOptions = Object.keys(grouped).sort().map(name => ({
          label: name,
          value: grouped[name].join(',') // Agrupa IDs: "1,2,3"
      }));
      
      // Recalcula seleção para manter consistência com novos valores agrupados
      const flatSelectedIds = [];
      if (Array.isArray(selectedIds)) {
          selectedIds.forEach(val => {
              // Garante que lidamos com strings e split caso já venha agrupado
              String(val).split(',').forEach(id => flatSelectedIds.push(String(id)));
          });
      }
      
      const newSelectedValues = [];
      newOptions.forEach(opt => {
          const optIds = opt.value.split(',');
          // Se algum dos IDs da opção agrupada estava selecionado, mantém selecionado
          const hasMatch = optIds.some(id => flatSelectedIds.includes(id));
          if (hasMatch) {
              newSelectedValues.push(opt.value);
          }
      });

      setServiceOptions(newOptions);
      // Atualiza os selecionados para o formato agrupado
      if (JSON.stringify(newSelectedValues) !== JSON.stringify(selectedIds)) {
          setSelectedServices(newSelectedValues);
      }
      
    } catch (e) {
      console.error(e);
    }
  }

  async function loadEntities(type, context, overrideCIds = null) {
    if (!type) return;
    const cIds = overrideCIds || selectedCompanyIds;
    const idsToLoad = Array.isArray(cIds) ? cIds : (cIds ? [cIds] : []);
    
    if (idsToLoad.length === 0) {
        if (context === 'target') setTargetEntities([]);
        else setTeamEntities([]);
        return;
    }

    // Optimization: if single company and preloaded data matches, use it
    if (idsToLoad.length === 1) {
        const cId = idsToLoad[0];
        let data = null;
        switch (type) {
          case 'employee': data = preloadedEmployees; break;
          case 'customer': data = preloadedCustomers; break;
          case 'supplier': data = preloadedSuppliers; break;
          case 'accountant': data = preloadedAccountants; break;
          case 'user': data = preloadedUsers; break;
          case 'service_station': data = preloadedServiceStations; break;
        }
        
        const canUsePreloaded = data && data.length > 0 &&
          (String(data[0].company_id) === String(cId) || String(data[0]._companyId) === String(cId));
          
        if (canUsePreloaded) {
            const options = data.map(e => ({
                value: String(e.id),
                label: e.name || e.corporate_name || e.trade_name || e.username || e.description || `ID ${e.id}`
            }));
            if (context === 'target') setTargetEntities(options);
            else setTeamEntities(options);
            return;
        }
    }

    try {
      if (context === 'target') setTargetEntities([]);
      
      const promises = idsToLoad.map(id => Api.getEntitiesByType(id, type).then(data => ({ id, data })).catch(err => ({ id, data: [], error: err })));
      const results = await Promise.all(promises);
      
      let allOptions = [];
      results.forEach(({ id, data }) => {
          // A API retorna erro as vezes como objeto, verifica se é array
          const items = Array.isArray(data) ? data : [];
          
          if (items.length > 0) {
              const companyName = getCompanyName(id);
              const options = items.map(e => ({
                value: String(e.id),
                label: idsToLoad.length > 1 
                    ? `${e.name || e.corporate_name || e.trade_name || e.username || e.description || `ID ${e.id}`} - ${companyName}`
                    : (e.name || e.corporate_name || e.trade_name || e.username || e.description || `ID ${e.id}`)
              }));
              allOptions = [...allOptions, ...options];
          }
      });
      
      if (allOptions.length === 0) {
        toast.info('Nenhum registro encontrado para este tipo nas empresas selecionadas.');
      }
      
      if (context === 'target') setTargetEntities(allOptions);
      else setTeamEntities(allOptions);
    } catch (e) {
      console.error(e);
      toast.error('Erro ao buscar dados.');
      if (context === 'target') setTargetEntities([]);
      else setTeamEntities([]);
    }
  }

  function handleChange(e) {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));

    if (id === 'target_type') {
      setFormData(prev => ({ ...prev, target_id: '' }));
      loadEntities(value, 'target');
    }
  }

  function handleTeamTypeChange(e) {
    setTeamEntityType(e.target.value);
    setTeamEntityId('');
    loadEntities(e.target.value, 'team');
  }

  function addTeamMember() {
    if (!teamEntityType || !teamEntityId) return;
    const exists = teamMembers.find(m => m.entity_type === teamEntityType && String(m.entity_id) === String(teamEntityId));
    if (exists) {
      toast.warning('Membro já adicionado.');
      return;
    }
    const entityOption = teamEntities.find(e => e.value === teamEntityId);
    setTeamMembers(prev => [...prev, {
      entity_type: teamEntityType,
      entity_id: Number(teamEntityId),
      entity_name: entityOption ? entityOption.label : '',
    }]);
    setTeamEntityId('');
  }

  function removeTeamMember(index) {
    setTeamMembers(prev => prev.filter((_, i) => i !== index));
  }

  function addCustomDate() {
    if (!tempDate) return;
    if (customDates.includes(tempDate)) {
      toast.warning('Data já adicionada.');
      return;
    }
    const newDates = [...customDates, tempDate].sort();
    setCustomDates(newDates);
    setTempDate('');
    
    // Update next_execution_date to the earliest date
    if (newDates.length > 0) {
        setFormData(prev => ({ ...prev, next_execution_date: newDates[0] }));
    }
  }

  function removeCustomDate(dateToRemove) {
    const newDates = customDates.filter(d => d !== dateToRemove);
    setCustomDates(newDates);
    
    // Update next_execution_date
    if (newDates.length > 0) {
         setFormData(prev => ({ ...prev, next_execution_date: newDates[0] }));
    } else {
         setFormData(prev => ({ ...prev, next_execution_date: '' }));
    }
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (selectedCompanyIds.length === 0) {
      toast.error('Selecione ao menos uma empresa.');
      return;
    }
    if (!formData.target_type || !formData.target_id) {
      toast.error('Selecione o alvo da ordem.');
      return;
    }
    if (!formData.service_type) {
      toast.error('Selecione o tipo de serviço.');
      return;
    }
    if (!formData.request_type) {
      toast.error('Selecione o tipo de solicitação.');
      return;
    }

    const targetOption = targetEntities.find(e => String(e.value) === String(formData.target_id));
    let targetName = targetOption ? targetOption.label : '';

    // Fallback: se não encontrou na lista (ex: erro de carga) mas é o mesmo da edição, mantém o nome original
    if (!targetName && initialData && String(initialData.target_id) === String(formData.target_id)) {
      targetName = initialData.target_name || '';
    }

    // Usa a primeira empresa selecionada como referência principal
    const primaryCompanyId = selectedCompanyIds[0];

    const payload = {
      _companyId: Number(primaryCompanyId),
      company_ids: selectedCompanyIds.map(Number), // Envia array de IDs
      company_id: Number(primaryCompanyId), // Mantém compatibilidade
      title: formData.title || null,
      target_type: formData.target_type,
      target_id: Number(formData.target_id),
      target_name: targetName,
      requires_photos: formData.requires_photos === 'true',
      service_type: formData.service_type,
      request_type: formData.request_type,
      next_execution_date: formData.next_execution_date || null,
      period_type: formData.period_type || null,
      custom_dates: formData.period_type === 'custom' ? customDates : [],
      period_quantity: formData.period_quantity ? Number(formData.period_quantity) : null,
      reminder_days_before: formData.reminder_days_before ? Number(formData.reminder_days_before) : null,
      execution_time: formData.execution_time ? Number(formData.execution_time) : 0,
      preferred_time: formData.preferred_time || null,
      value: normalizeCurrencyValue(formData.value),
      observation: formData.observation || null,
      services: selectedServices.flatMap(s => String(s).split(',').map(n => Number(n))),
      team: teamMembers,
    };

    onSuccess(payload);
  }

  const typeLabel = (type) => {
    const found = TARGET_TYPES.find(t => t.value === type);
    return found ? found.label : type;
  };

  const typeLabelExecutor = (type) => {
    const found = TARGET_TYPES_EXECUTORS.find(t => t.value === type);
    return found ? found.label : type;
  };

  const getMapperLabel = (label) => {
    switch (label) {
      case 'customer':
        return 'Cliente';
      case 'supplier':
        return 'Fornecedor';
      case 'employee':
        return 'Funcionário';
      case 'accountant':
        return 'Contador';
      case 'user':
        return 'Usuário';
      case 'service_station':
        return 'Estação de Serviço';
      default:
        return label;
    }
  };

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} title={isEdit ? 'Editar Ordem de Serviço' : 'Nova Ordem de Serviço'} size="lg">
      <form onSubmit={handleSubmit} className="company-form-component">
        <div className="form-body">
          <h3 className="section-title" style={{ marginTop: 0 }}>Empresa</h3>
          <div className="form-grid" style={{ gridTemplateColumns: '1fr' }}>
            <Select
              id="company_id"
              label="Empresa *"
              options={[
                // { value: '', label: 'SELECIONE...' }, // Removemos opção vazia para Select multiple
                ...companies.map(c => ({
                  value: String(c.id),
                  label: c.corporate_name || c.trade_name || c.name || c.razao_social || c.nome_fantasia || `Empresa ${c.id}`,
                })),
              ]}
              value={selectedCompanyIds}
              onChange={e => {
                // Select multiple retorna array de valores no evento personalizado do componente Select (se suportar)
                // Se for o componente Select padrão do projeto, ele geralmente retorna o value direto no target.value
                // Mas para multiple, precisamos ver como ele se comporta.
                // Assumindo que o componente Select do projeto foi adaptado para multiple como no ServiceModal
                // No ServiceModal do usuário, ele pediu para usar o Select com checkbox.
                // O componente Select com multiple={true} deve retornar um array.
                
                // Verificando implementação típica de Select multiple no projeto (baseado em BankAccountForm):
                // O value vem como array.
                const val = e.target.value; 
                const newIds = typeof val === 'string' ? [val] : val;
                
                setSelectedCompanyIds(newIds);
                
                // Mantemos o target_type para recarregar a lista, mas limpamos o ID
                setFormData(prev => ({ ...prev, target_id: '' }));
                // Não limpamos listas ou seleções para permitir repopulação/manutenção
                
                // Carrega serviços das empresas selecionadas
                if (newIds.length > 0) {
                    loadServices(newIds);
                } else {
                    setServiceOptions([]);
                    setTargetEntities([]);
                    setTeamEntities([]);
                    setSelectedServices([]);
                }
              }}
              placeholder="SELECIONE AS EMPRESAS..."
              searchable
              multiple={true}
            />
          </div>

          <h3 className="section-title">Detalhes</h3>
          
          <div className="full-width" style={{marginBottom: '20px'}}>
            <Input
              id="title"
              label="Nome da OS"
              value={formData.title}
              onChange={handleChange}
            />
          </div>

        <div className="form-grid">
            <Select
              id="target_type"
              label="Tipo do Alvo"
              options={TARGET_TYPES}
              value={formData.target_type}
              onChange={handleChange}
              placeholder="SELECIONE..."
            />
            <Select
              id="target_id"
              label="Alvo"
              options={targetEntities}
              value={formData.target_id}
              onChange={handleChange}
              placeholder={formData.target_type ? 'SELECIONE...' : 'SELECIONE O TIPO PRIMEIRO'}
              searchable
            />
          </div>

          <h3 className="section-title">Serviço</h3>
          <div className="form-grid">
            <Select
              id="service_type"
              label="Tipo de Serviço"
              options={SERVICE_TYPES}
              value={formData.service_type}
              onChange={handleChange}
              placeholder="SELECIONE..."
            />
            <Select
              id="requires_photos"
              label="Exige Fotos?"
              options={REQUIRES_PHOTOS_OPTIONS}
              value={formData.requires_photos}
              onChange={handleChange}
            />
            <div className="full-width">
              <MultiSelect
                id="services"
                label="Serviços"
                options={serviceOptions}
                value={selectedServices}
                onChange={setSelectedServices}
                placeholder="Selecione os serviços..."
              />
            </div>
            <Select
              id="request_type"
              label="Tipo de Solicitação"
              options={REQUEST_TYPES}
              value={formData.request_type}
              onChange={handleChange}
              placeholder="SELECIONE..."
            />
            <Input
              id="value"
              label="Valor (R$)"
              mask="currency"
              value={formData.value}
              onChange={handleChange}
            />
          </div>

          <h3 className="section-title">Agendamento</h3>
          <p style={{ margin: '0 0 12px', color: 'var(--text-secondary)', fontSize: 13 }}>
            Opcional. Use estes campos para deixar a OS pré-agendada. Você pode escolher hoje ou qualquer data futura.
            Se não informar nada, a ordem ficará sem próxima execução recorrente.
          </p>
          <div className="form-grid">
            <Select
              id="period_type"
              label="Recorrência"
              options={PERIOD_TYPES}
              value={formData.period_type}
              onChange={handleChange}
            />
            {formData.period_type !== 'custom' && (
                <Input
                  id="next_execution_date"
                  label="Data da execução"
                  type="date"
                  value={formData.next_execution_date}
                  onChange={handleChange}
                />
            )}
            <Select
              id="preferred_time"
              label="Horário preferencial"
              options={TIME_OPTIONS}
              value={formData.preferred_time}
              onChange={handleChange}
            />
            {formData.period_type !== 'custom' && (
                <Input
                  id="period_quantity"
                  label="Intervalo da recorrência (opcional)"
                  type="number"
                  value={formData.period_quantity}
                  onChange={handleChange}
                  placeholder="Ex: 2"
                  disabled={!formData.period_type}
                />
            )}
            <RangeSlider
              id="execution_time"
              label="Tempo de execução (opcional)"
              value={formData.execution_time}
              onChange={handleChange}
              min={0}
              max={20}
              step={1}
              suffix="dias"
              hint="Prazo estimado para concluir a ordem de serviço após o início da execução."
            />
          </div>

          {formData.period_type === 'custom' && (
             <div className="custom-dates-section" style={{ marginTop: '1rem', border: '1px solid var(--border-color)', padding: '1rem', borderRadius: '8px' }}>
                <h4 style={{marginTop: 0, marginBottom: '1rem', fontSize: '14px'}}>Datas Específicas</h4>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '1rem', alignItems: 'flex-end' }}>
                   <div style={{ flex: 1 }}>
                     <Input
                       id="temp_date"
                       label="Adicionar Data"
                       type="date"
                       value={tempDate}
                       onChange={(e) => setTempDate(e.target.value)}
                     />
                   </div>
                   <Button type="button" onClick={addCustomDate} disabled={!tempDate} style={{ marginBottom: '1px' }}>
                     Adicionar
                   </Button>
                </div>
                
                <div className="custom-dates-list" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                   {customDates.length === 0 && <span style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>Nenhuma data selecionada.</span>}
                   {customDates.sort().map((date, idx) => (
                      <div key={idx} style={{ background: 'var(--surface-color)', padding: '4px 8px', borderRadius: '4px', border: '1px solid var(--border-color)', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
                         <span>{new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</span>
                         <button type="button" onClick={() => removeCustomDate(date)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: 'var(--text-secondary)', display: 'flex', alignItems: 'center' }}>
                            <FiX size={14} />
                         </button>
                      </div>
                   ))}
                </div>
             </div>
          )}

          <h3 className="section-title">Observações</h3>
          <div className="form-grid" style={{ gridTemplateColumns: '1fr' }}>
            <Input
              id="observation"
              label="Observação"
              value={formData.observation}
              onChange={handleChange}
              multiline
              rows={3}
            />
          </div>

          <h3 className="section-title">Equipe Executora</h3>
          <div className="form-grid" style={{ marginBottom: '16px' }}>
            <Input
              id="reminder_days_before"
              label="Lembrar equipe (dias antes)"
              type="number"
              value={formData.reminder_days_before}
              onChange={handleChange}
              placeholder="Ex: 3"
              hint="Quantidade de vezes/dias que o usuário será lembrado antes da data do serviço."
            />
          </div>
          <div className="so-team-add-row">
            <Select
              id="team_entity_type"
              label="Tipo"
              options={TARGET_TYPES_EXECUTORS}
              value={teamEntityType}
              onChange={handleTeamTypeChange}
              placeholder="SELECIONE..."
            />
            <MultiSelect
              id="team_members"
              label="Membros"
              options={teamEntityType ? teamEntities : []}
              value={teamMembers
                .filter(m => m.entity_type === teamEntityType)
                .map(m => String(m.entity_id))}
              onChange={(newValues) => {
                setTeamMembers(prev => {
                  const others = prev.filter(m => m.entity_type !== teamEntityType);
                  const nextForType = (newValues || []).map(id => {
                    const existing = prev.find(
                      m => m.entity_type === teamEntityType && String(m.entity_id) === String(id)
                    );
                    if (existing) return existing;
                    const entityOption = teamEntities.find(e => e.value === id);
                    return {
                      entity_type: teamEntityType,
                      entity_id: Number(id),
                      entity_name: entityOption ? entityOption.label : '',
                    };
                  });
                  return [...others, ...nextForType];
                });
              }}
              placeholder={teamEntityType ? 'Selecione os membros...' : 'Selecione o tipo primeiro'}
              searchable
            />
          </div>

          {teamMembers.length > 0 && (
            <div className="so-team-list">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="so-team-item">
                  <span className="so-team-item-name">{member.entity_name}</span>
                  <span className="so-team-item-type">{getMapperLabel(typeLabel(member.entity_type))}</span>
                  <button type="button" onClick={() => removeTeamMember(idx)}>
                    <FiX size={14} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-actions">
          <Button type="button" className="cancel-button" onClick={onClose}>Cancelar</Button>
          <Button type="submit" disabled={loading}>
            {loading ? 'Salvando...' : isEdit ? 'Salvar' : 'Salvar'}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
